const truncateStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 2px'
  };
  
  export const tableColumns = [
    {
      name: 'Artifact ID',
      selector: row => row.artifact_id,
      sortable: true,
      center: true,
      width: '120px',
      style: truncateStyle,
    },
    {
      name: 'Title',
      selector: row => row.title,
      sortable: true,
      center: true,
      width: '150px',
      cell: row => (
        <div style={{ 
          ...truncateStyle,
          color: '#5C61F2', 
          fontWeight: 'bold',
          width: '100%',
          textAlign: 'center'
        }}>
          {row.title}
        </div>
      ),
    },
    {
      name: 'Short Description',
      selector: row => row.description,
      sortable: true,
      center: true,
      width: '180px',
      style: truncateStyle,
    },
    {
      name: 'Artifact Type',
      selector: row => row.type,
      sortable: true,
      center: true,
      width: '140px',
      style: truncateStyle,
    },
    {
      name: 'Category',
      selector: row => row.category,
      sortable: true,
      center: true,
      width: '210px',
      style: truncateStyle,
    },
    {
      name: 'Promote as',
      selector: row => row.promote_as,
      sortable: true,
      center: true,
      width: '140px',
      style: truncateStyle,
    },
    {
      name: 'Created Date',
      selector: row => row.created_date,
      sortable: true,
      center: true,
      width: '140px',
      style: truncateStyle,
    },
    {
      name: 'Status',
      selector: row => row.status_component,
      sortable: true,
      center: true,
      width: '100px',
      id: 'status',
      style: truncateStyle,
    },
    {
      name: 'Action',
      selector: row => row.action,
      sortable: false,
      center: true,
      width: '160px',
      id: 'action',
      style: truncateStyle,
    }
  ];